<template>
    <article>

        <section class="float-right m-2">
            Search: <search-box :list="dataItems" :filteredList="filteredList" :fields="['name','file_type.name', 'user.name','created_at']" ></search-box>
        </section>

        <section class="table-responsive">
            <table class="table table-borderless">

                <thead>
                    <th>File<sort-button style="color:blue" field="name" :list="dataItems"></sort-button></th>
                    <th>Type<sort-button style="color:blue" field="file_type.name" :list="dataItems"></sort-button></th>
                    <th>Uploaded By<sort-button style="color:blue" field="user.name" :list="dataItems"></sort-button></th>
                    <th>Date<sort-button style="color:blue" field="created_at" :list="dataItems"></sort-button></th>
                    <th>Actions</th>
                </thead>

                <tbody>
                    <tr v-for="(item, key) in filteredList" :key="key">
                        <td> <div class="form-group"> <span>{{ item.name }}</span> </div> </td>
                        <td> <div class="form-group"> <span>{{ item.file_type.name }}</span> </div> </td>
                        <td> <div class="form-group"> <span>{{ item.user.name }}</span> </div> </td>
                        <td> <div class="form-group"> <span>{{ item.created_at }}</span> </div> </td>
                        <td>
                            <a v-if="userPermissions['view']" :href="item.link" class="btn btn-view border border-dark"> Download </a>
                            <delete-button :user-permissions="userPermissions" @click="onDelete(item)"> Delete </delete-button>
                        </td>
                    </tr>
                </tbody>

            </table>
        </section>

        <section class="table-responsive">
            <table v-if="uploadingFiles.length > 0" class="table table-borderless">

                <thead> <tr> <th>File</th> <th>Actions</th> </tr> </thead>

                <tbody>
                    <tr v-for="(item, index) in uploadingFiles" :key="index">
                        <td>
                            <small>{{ item.name }}</small>
                            <div class="progress">
                                <div
                                    class="progress-bar"
                                    role="progressbar"
                                    :style="{width: item.completed+'%'}"
                                    aria-valuenow="25"
                                    aria-valuemin="0"
                                    aria-valuemax="100" >
                                </div>
                            </div>
                        </td>
                        <td> <delete-button :user-permissions="userPermissions" @click="onCancel(item)"> Cancel </delete-button> </td>
                    </tr>
                </tbody>

            </table>
        </section>

        <input id="file-upload" name="file" type="file" style="display: none" @change="onFileChange" />
        <add-button :user-permissions="userPermissions" @click="onUploadFile"> Add </add-button>
        <status-feedback :successFeedback="successFeedback" :failFeedback="failFeedback" :errors="errors" ></status-feedback>

        <section class="alert alert-warning my-4">
            <p>Allowed file types:</p>
            <ul>
                <li v-for="item of allowedFileTypes">
                    For
                    <strong>{{ item[0].name }}:</strong>
                    <span class="text-monospace">{{ item[0].extensions }}</span>
                </li>
                <li>Any type of file has a limit of <strong>maximum 10 MB</strong> in size.</li>
            </ul>
        </section>

    </article>
</template>

<script>

import TableComponentsMixin from '../mixins/TableComponentsMixin';
import PermissionButtons from '../mixins/PermissionButtonsMixin';
import AjaxListMixin from '../mixins/AjaxListMixin';

export default {

    mixins: [AjaxListMixin, TableComponentsMixin, PermissionButtons],

    props: {

        items: {
            type: Array,
            default: () => { return []; }
        },

        fileUrl: {
            type: String,
            default: 'file',
        },

        allowedFileTypes:{
            type: Object,
            required: true
        }

    },

    data() {

        return {
            url: this.fileUrl,
            dataItems: this.items,
            filteredList: [],
            uploadingFiles: [],
        };
    },


    methods: {

        uploadCompleted(item) {

            if (item.completed || item.completed < 100) {
                return false;
            }

            return true;
        },

        onCancel(item)
        {
            // in case someone pressed cancel after the upload is completed and is still saving on disk on backend
            if (item.completed >= 100) {
                return;
            }

            item.cancelSource.cancel();
            this._clearMessages();
            this.errors.file = ['Operation canceled.'];
            this._spliceByObjReference(this.uploadingFiles, item, null);
        },

        onFileChange(e)
        {
            let files = e.target.files || e.dataTransfer.files;

            if (!files.length) {
                return;
            }

            let cancelToken = window.axios.CancelToken;
            let cancelSource = cancelToken.source();

            let fileDummy = { 'name': files[0].name, 'completed': 0, 'cancelToken': cancelToken, 'cancelSource': cancelSource };

            this.uploadingFiles.push(fileDummy);

            let fileData = new FormData();
            fileData.append('file', files[0]);

            // set selected file to null so that selecting the same file still triggers changed event
            window.$('#file-upload').val(null);

            let config = {
                headers: { 'Content-Type': 'multipart/form-data' },
                cancelToken: cancelSource.token,
                onUploadProgress: progress => {
                    fileDummy.completed = Math.round((progress.loaded * 100) / progress.total);
                } };


            window.axios.post(this.url, fileData, config)
                .then(response => {
                    this._spliceByObjReference(this.uploadingFiles, fileDummy, null);
                    this.onAdd(response.data);
                    this._successCallback(response.data.id, response.data, null);
                })
                .catch(error => {
                    this._failCallback(null, error, null);
                    this._spliceByObjReference(this.uploadingFiles, fileDummy, null);
                });
        },

        onUploadFile()
        {
            // simulates click event on file input to trigger file upload dialog
            // this enables default file input element to stay hidden
            window.$('#file-upload').trigger('click');
        },
    },
};

</script>



// WEBPACK FOOTER //
// resources/assets/js/components/files/FileUploadComponent.vue